module.exports = __webpack_public_path__ + "img/v1_no4_p8.36a45625.jpg";